// extracted by mini-css-extract-plugin
export var label = "LabeledInputs-module--label--15-3U";
export var input = "LabeledInputs-module--input--6vVwJ";
export var ch2 = "LabeledInputs-module--ch2--2S88F";
export var ch2Container = "LabeledInputs-module--ch2-container--2VryW";